import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '2019年度科技互联网行业飙榜评选';

const route: RouteConfig = {
  path: '/2019KJHLW',
  name: 'KJHLW',
  component: () => import('./Home.vue'),
  redirect: '/2019KJHLW/first',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'first',
      component: () => import('./First.vue'),
      name: 'first',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'second',
      component: () => import('./Second.vue'),
      name: 'second',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'third',
      component: () => import('./Third.vue'),
      name: 'third',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
